import React from 'react';
import { Redux, Slices } from 'spwa-ui-library';
import css from './index.module.scss';
import noImg from '../../assets/no-itm.png';
const { useSelector } = Redux;
const { selectProductEntities } = Slices.productSlice;

function BundleStepThumb({ steps, val, idx, customizeBundle, productObj, custItem }) {
  const productsMap = useSelector(selectProductEntities);
  const stepIndex = val?.stepId ? val?.stepId : idx + 1;
  // console.log(steps, 'Product');
  const itemId = Object.keys(customizeBundle[stepIndex])[0];
  let itemOfBundle = productsMap[itemId];
  let stepsOfItem = steps;
  // if (!itemOfBundle) return '';
  if (productObj.bundleTypeId === 'bundle_group' && custItem.additionalInfo?.selectedBundleId) {
    const productBundleGroup = productsMap[custItem.additionalInfo?.selectedBundleId];
    stepsOfItem = productBundleGroup.steps;
  }

  if (itemOfBundle === undefined) {
    // debugger;
    let idOfStep = val?.stepId;
    if (idOfStep) {
      idOfStep = val?.stepId - 1;
    } else {
      idOfStep = idx;
    }
    const optionsExist = stepsOfItem[idOfStep]?.options;
    const stepItem = optionsExist?.findIndex((x) => x.id == itemId);
    if (stepItem !== undefined) itemOfBundle = optionsExist[stepItem];
  }
  // console.log(Object.keys(customizeBundle[stepIndex + 1]), 'bundle');

  let text = val?.stepId ? stepsOfItem[val?.stepId - 1]?.title : stepsOfItem[idx]?.title;

  if (text == productObj?.name || text == productObj?.title) {
    text = stepsOfItem[idx + 1]?.title || stepsOfItem[idx]?.title;
  }

  return (
    <>
      <div className={css.thumbnailImg}>
        <img
          src={itemOfBundle?.assets[0]?.src}
          alt="sub"
          width="100"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = noImg;
          }}
        />
        <span>{text}</span>
      </div>
    </>
  );
}

export default BundleStepThumb;
